import { render, staticRenderFns } from "./loginRegisterDialog.vue?vue&type=template&id=054932e8&scoped=true&"
import script from "./loginRegisterDialog.vue?vue&type=script&lang=ts&"
export * from "./loginRegisterDialog.vue?vue&type=script&lang=ts&"
import style0 from "./loginRegisterDialog.vue?vue&type=style&index=0&id=054932e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054932e8",
  null
  
)

export default component.exports